import api from './api';

/**
 * Engagement Service
 * Handles engagement agreements between Investors, Advisors, and Analysts
 */
export const engagementService = {
  /**
   * Create a new engagement agreement
   */
  async createAgreement(data) {
    return api.post('/engagement/agreement', data);
  },

  /**
   * Get engagement agreement by ID
   */
  async getAgreement(id) {
    return api.get(`/engagement/agreement/${id}`);
  },

  /**
   * Get all agreements for a user
   */
  async getMyAgreements(userId) {
    return api.get(`/engagement/agreement/user/${userId}`);
  },

  /**
   * Get all agreements for a user
   */
  async getMyAgreementsWithPortfolioValue(userId) {
    return api.get(`/engagement/agreement/portfolio/user/${userId}`);
  },

  /**
   * Update agreement status (e.g., sign)
   */
  async updateAgreementStatus(id, statusData) {
    return api.post(`/engagement/agreement/${id}/status`, statusData);
  },

  /**
   * Sign agreement
   */
  async signAgreement(id, signatureData) {
    return api.post(`/engagement/agreement/${id}/sign`, signatureData);
  },

  /**
   * Invalidate an existing agreement
   */
  async invalidateAgreement(id) {
    return api.put(`/engagement/agreement/${id}/invalidate`);
  },

  /**
   * Get fee structure pricing list
   */
  async getFeeStructurePricingList(role, userId) {
    return api.get(`/engagement/agreement/fee-structure-pricing-list/${role}/${userId}`);
  }
};

export default engagementService;
